export default {
  frontRoutes: [
    {
      path: "/exam",
      name: "ExamIndex",
      component: () =>
        import(/* webpackChunkName: "exam" */ "../views/exam/ExamIndex.vue"),
    },
    {
      path: "/exam/freedom/rule",
      name: "ExamFreedomRule",
      component: () =>
        import(
          /* webpackChunkName: "exam" */ "../views/exam/ExamFreedomRule.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/freedom/do",
      name: "ExamFreedomDo",
      component: () =>
        import(
          /* webpackChunkName: "exam" */ "../views/exam/ExamFreedomDo.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/freedom/report",
      name: "ExamFreedomReport",
      component: () =>
        import(
          /* webpackChunkName: "exam" */ "../views/exam/ExamFreedomReport.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/freedom/analysis",
      name: "ExamFreedomAnalysis",
      component: () =>
        import(
          /* webpackChunkName: "exam" */ "../views/exam/ExamFreedomAnalysis.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/package",
      name: "ExamPackage",
      component: () =>
        import(/* webpackChunkName: "exam" */ "../views/exam/ExamPackage.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/package/report",
      name: "ExamPackageReport",
      component: () =>
        import(
          /* webpackChunkName: "exam" */ "../views/exam/ExamPackageReport.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/package/analysis",
      name: "ExamPackageAnalysis",
      component: () =>
        import(
          /* webpackChunkName: "exam" */ "../views/exam/ExamPackageAnalysis.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/package/paper",
      name: "ExamPackagePaper",
      component: () =>
        import(
          /* webpackChunkName: "exam" */ "../views/exam/ExamPackagePaper.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/package/paper/detail",
      name: "ExamPackagePaperDetail",
      component: () =>
        import(
          /* webpackChunkName: "exam" */ "../views/exam/ExamPackagePaperDetail.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/package/do",
      name: "ExamPackageDo",
      component: () =>
        import(
          /* webpackChunkName: "exam" */ "../views/exam/ExamPackageDo.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/simulation",
      name: "ExamSimulation",
      component: () =>
        import(
          /* webpackChunkName: "exam" */ "../views/exam/ExamSimulation.vue"
        ),
      meta: {
        requireAuth: false,
      },
    },
    {
      path: "/exam/point",
      name: "ExamPoint",
      component: () =>
        import(/* webpackChunkName: "exam" */ "../views/exam/ExamPoint.vue"),
      meta: {
        requireAuth: false,
      },
    },
    {
      path: "/exam/random/do",
      name: "ExamRandomDo",
      component: () =>
        import(/* webpackChunkName: "exam" */ "../views/exam/ExamRandomDo.vue"),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/random/report",
      name: "ExamRandomReport",
      component: () =>
        import(
          /* webpackChunkName: "exam" */ "../views/exam/ExamRandomReport.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/random/analysis",
      name: "ExamRandomAnalysis",
      component: () =>
        import(
          /* webpackChunkName: "exam" */ "../views/exam/ExamRandomAnalysis.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/special/do",
      name: "ExamSpecialDo",
      component: () =>
        import(
          /* webpackChunkName: "exam" */ "../views/exam/ExamSpecialDo.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/special/report",
      name: "ExamSpecialReport",
      component: () =>
        import(
          /* webpackChunkName: "exam" */ "../views/exam/ExamSpecialReport.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/special/analysis",
      name: "ExamSpecialAnalysis",
      component: () =>
        import(
          /* webpackChunkName: "exam" */ "../views/exam/ExamSpecialAnalysis.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
    {
      path: "/exam/wrong/do",
      name: "ExamWrongDo",
      component: () =>
        import(
          /* webpackChunkName: "exam" */
          "../views/exam/ExamWrongDo.vue"
        ),
      meta: {
        requireAuth: true,
      },
    },
  ],
  memberRoutes: [
    {
      path: "/member/evaluation",
      name: "MemberEvaluation",
      component: () =>
        import(
          /* webpackChunkName: "member-exam" */
          "../views/member/MemberEvaluation.vue"
        ),
      meta: {
        requireAuth: true,
        title: "我的测评",
        root: true,
      },
    },
  ],
};
